<template>
  <div class="register-page">
    <div class="row align-items-center header">
      <div class="page-title col-xs-12 col-sm-6 pt-2">
        Registrar / Setores ({{ list.length }})
      </div>
      <toolbar
        class="col-xs-12 col-sm-6"
        type="sectors"
        :is-mobile="mobile"
        :is-searching="isSearching"
        @search="searchBy"
        @clear-search="clearSearch"
        @edit="edit"
        @remove="removeDialog()"
        @add="add"
        :is-admin="isAdmin"
        :selected="selected"
        :number-of-elements="list.length"
        :type-filtering="''"
        ref="INP"
        :is-show="loading"
        :not-exists="showErrorNotFound"
        :not-search="showErrorNotSearch"
      />
    </div>

    <div class="register-main">
      <b-modal
        ref="removeSectorDialog"
        centered
        cancel-variant="outline-secondary"
        title="Atenção!"
        ok-title="Deletar"
        ok-variant="danger"
        @ok="confirmRemove"
        cancel-title="Cancelar"
      >
        <div class="title-modal-info">
          {{ selected.length }}
          {{
            selected.length == 1
              ? "setor será excluído."
              : "setores serão excluídos."
          }}
        </div>
      </b-modal>

      <b-modal
        centered
        ref="dialogWait"
        no-close-on-backdrop
        no-close-on-esc
        size="sm"
        hide-header
        hide-footer
      >
        <div class="center-xs">
          <spinner />
        </div>
        <div class="center-xs pt-3" v-if="currentLoadingMessage">
          {{ currentLoadingMessage }}
        </div>
      </b-modal>

      <div class="list-items row">
        <div v-if="loading && !isSectorRegister" class="col-xs-12 center-xs">
          <spinner /> Aguarde...
        </div>
        <div
          v-if="showErrorNotFound"
          class="
            EmptyRequest
            w-100
            h-100
            p-0
            row
            center-xs center-md center-sm center-xs
            mt-3
          "
        >
          <img :src="emptyIcon" class="empty" />
          <span>Não há setores para exibir.</span>
        </div>

        <div
          v-if="showErrorNotSearch && !showErrorNotFound"
          class="EmptyRequest row center-xs mx-2 md-12 w-100 p-0 mt-3"
          style="text-align: left"
        >
          <img :src="searchIcon" class="empty" />
          <span>
            Nenhum resultado encontrado. Para voltar a exibir todas os setores
            <b-link @click="clearSearch"> clique aqui </b-link> .
          </span>
        </div>

        <div
          v-for="(item, index) in list"
          :key="index"
          class="col-xs-12 col-sm-4 col-md-3"
        >
          <div class="item-card sector-card">
            <div class="header-card">
              <div class="d-flex justify-content-between">
                <h5>{{ item.NAME }}</h5>
                <div>
                  <active-user-icon
                    v-if="item.EDITOR_NAME"
                    :alt="`Último editor: ${item.EDITOR_NAME}`"
                    title=""
                    class="action-icon-right details-btn m-0 edited-icon"
                    :id="`editor${item.NAME}`"
                  />
                  <b-tooltip
                    :ref="`editor${item.NAME}`"
                    :target="`editor${item.NAME}`"
                    placement="bottomleft"
                  >
                    Último editor: {{ item.EDITOR_NAME }}
                  </b-tooltip>
                  <code-not-equal-icon
                    title="É de manejo"
                    class="management-icon"
                    v-if="item.IS_MANAGEMENT"
                  />
                </div>
              </div>
              <sector-icon title="Área" class="sector-icon" />
              <span class="info">{{ item.AREA ? item.AREA + " ha" : "" }}</span>
            </div>
            <div class="row-details-card">
              <div class="left">
                <leaf-icon title="Fruto cultivado" />
                <span>Fruto cultivado</span>
              </div>
              <!-- <span>ASDASD</span> -->
              <span>{{ item.FARM_NAME || item.PLANTING_TYPE || "..." }}</span>
            </div>
            <!-- <br /> -->
            <div class="row-details-card">
              <div class="left">
                <calendar-icon title="Data de plantio" />
                <span>Data de plantio</span>
              </div>

              <span>
                {{
                  item.PLANTING_DATE ? formatDate(item.PLANTING_DATE) : "..."
                }}</span
              >
            </div>
            <div class="row-details-card">
              <div class="left">
                <calendar-icon title="Data de plantio" />
                <span>Data de colheita</span>
              </div>
              <!-- <span>ASDASD</span> -->
              <span>
                {{
                  "DATE_CROP" in item && item.DATE_CROP
                    ? formatDate(item.DATE_CROP)
                    : "..."
                }}</span
              >
            </div>

            <div class="row-details-card">
              <div class="left">
                <note-icon title="Observações" />
                <span>Observações</span>
              </div>

              <span>{{ noteFormat(item.NOTE) }}</span>
            </div>
            <div class="row-details-card">
              <div class="left">
                <edited-agn-icon title="Data de edição" />
                <span>Atualizado em </span>
              </div>

              <span>
                {{
                  item.UPDATE ? formatFullDateTime(item.UPDATE) : "..."
                }}</span
              >
            </div>
            <!-- <br />s -->
            <div class="footer">
              <b-checkbox
                class="checkbox"
                v-show="isAdmin"
                :value="item"
                v-model="selected"
              />
              <div class="show-details-cards">
                <b-link @click="openDetails(item)">Ver equipamentos</b-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="showDetails">
      <div id="overlay" @click="showDetails = false"></div>
      <div id="details">
        <header id="header" class="row">
          <div class="col-xs-12 monit-item bg-3v3">
            <h5>Setor {{ item.NAME }}</h5>
          </div>
        </header>
        <div class="column details-area">
          <div class="col-xs-12 content">
            <h5>Bombas</h5>
            <div class="selected-box">
              <div v-if="!item.pumps.length">
                Não há bombas cadastradas no setor {{ item.NAME }}.
              </div>
              <div
                class="selected-item"
                v-for="pump in item.pumps"
                :key="pump.ID"
              >
                {{ pump.NAME }}
              </div>
            </div>
            <h5>Válvulas</h5>
            <div class="selected-box">
              <div v-if="!item.valves.length">
                Não há válvulas cadastradas no setor {{ item.NAME }}.
              </div>
              <div
                class="selected-item"
                v-for="valve in item.valves"
                :key="valve.ID"
              >
                {{ valve.NAME }}
              </div>
            </div>
            <h5>Hidrômetros</h5>
            <div class="selected-box">
              <div v-if="!item.hydros.length">
                Não há hidrômetros cadastrados no setor {{ item.NAME }}.
              </div>
              <div
                class="selected-item"
                v-for="hydro in item.hydros"
                :key="hydro.ID"
              >
                {{ hydro.NAME }}
              </div>
            </div>
            <h5>Sensores</h5>
            <div class="selected-box">
              <div v-if="!item.sensors.length">
                Não há sensores cadastrados no setor {{ item.NAME }}.
              </div>
              <div
                class="selected-item"
                v-for="sensor in item.sensors"
                :key="sensor.ID"
              >
                {{ sensor.NAME }}
              </div>
            </div>
          </div>
        </div>
        <footer id="footer">
          <b-btn size="sm" block @click="showDetails = false"> Fechar </b-btn>
        </footer>
      </div>
    </div>
    <sector-form
      :has-access="managementAccess"
      :show-form="showForm"
      :form-type="formType"
      :old-name="formType == 'edit' && selected.length && selected[0].NAME"
      :already-used-names="fullList.map((e) => e.NAME)"
      :item-to-edit="selected[0]"
      :hydros="hydros"
      :pumps="pumps"
      :valves="valves"
      :sensors="sensors"
      @submit="onSubmitForm"
      @close-form="showForm = false"
    />
  </div>
</template>

<script>
import { sectors } from "@/api";
import { cookies } from "@/pages/components/cookies";

import managementSectorsActions from "@/mixins/managementSectorActions.js";

import { managementSectorUseCases } from "../../../api/modules/sector/useCases";
import moment from "moment";

import { deleteLogSectorByIdUseCase } from "../../../api/modules/log_sector/useCase/delete";

import { deleteManagementByIdSector } from "../../../api/modules/management/useCase/deleteByIdSector";
import { deleteVolumeBySector } from "../../../api/modules/volume/useCases/deleteRecordsVolumesBySector";

import { checkIfFarmDapExists } from "@/api/modules/farms_dap/useCases/checkIfExistsFarmDap";
import { getManagementRainfallInputByIdlUseCase } from "@/api/modules/management/useCase/getRainfallInputsByIdSector";

export default {
  name: "sectors",
  props: {
    mobile: Boolean,
    managementAccess:Boolean,
  },
  mixins: [managementSectorsActions],
  created() {
    this.$emit("title-change", "Setores");
    this.loadSectors();
    this.loadEquipments();
    this.isAdmin = Number(cookies.get("PERMISSION")) == 1;
    console.log("TEM ACESSO A MANEJO? ", this.managementAccess)
  },
  data() {
    return {
      loadingMessages: {
        actuator: {
          get: "Buscando dados da válvula...",
        },
        sector: {
          create: "Criando setor...",
          update: "Atualizando dados adicionais do setor de manejo...",
        },
        management: {
          calc: "Calculando dados de manejo...",
          create: "Salvando dados calculados de manejo...",
          delete: "Apagando dados de manejo do setor...",
        },
      },
      currentLoadingMessage: "",
      showForm: false,
      showDetails: false,
      isAdmin: false,
      loading: true,
      isSectorRegister: false,
      selected: [],
      list: [],
      fullList: [],
      isSearching: false,
      showErrorNotFound: false,
      showErrorNotSearch: false,
      emptyIcon: require("../../../assets/icons/Empty.svg"),
      searchIcon: require("../../../assets/icons/search.svg"),
      filter: "",
      item: {},
      valves: [],
      hydros: [],
      pumps: [],
      hours: [
        "00",
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "20",
        "21",
        "22",
        "23",
      ],
      sensors: [],
      formType: "",
      recalcUntilDateCrop: false,
      // oldValves: [], //Armazena a válvula anterior antes de trocar
      currentValves: [], //Armazena a válvula anterior antes de trocar
    };
  },
  watch: {
    sectorsLength: {
      handler(newValue, oldValue) {
        const sectorId = this.$route.query.id;
        const sectorToEdit = this.list.find((sector) => sector.ID == sectorId);
        if (sectorId && !oldValue && newValue && sectorToEdit) {
          this.selected = [sectorToEdit];
          this.edit();
        }
      },
    },
    showForm: {
      handler(newValue, oldValue) {
        const sectorId = this.$route.query.id;
        // TODO
        // FROM MANAGEMENT MONITORING PAGE PUT A BUTTON TO THIS PAGE WITH id ON ROUTER QUERY
        if (oldValue && !newValue && sectorId) {
          this.$router.replace({ query: null });
        }
      },
    },
    loading(newValue) {
      if (this.isSectorRegister) {
        if (newValue == true) {
          this.$refs.dialogWait.show();
        } else {
          this.$refs.dialogWait.hide();
          this.isSectorRegister = false;
        }
      } else {
        if (newValue) {
          wait.show();
        } else {
          wait.hide();
        }
      }
    },
  },
  computed: {
    sectorsLength() {
      return this.list.length;
    },
    computedClass() {
      let className = "row align-items-center header";
      if (this.mobile) {
        className = "row align-items-center header-mobile";
        return className;
      }
      return className;
    },
    validFilter() {
      return !!this.filter.split(" ").join("");
    },
  },
  methods: {
    formatFullDateTime(date) {
      return moment(date).format("DD/MM/YYYY HH:mm:ss");
    },
    noteFormat(value) {
      if (value) {
        if (value.length > 15) {
          return value.slice(0, 15) + "...";
        } else {
          return value;
        }
      }

      return "...";
    },
    //Calcular Predição da ET0 baseando nos dados do array de ET0
    //buscados no banco
    async loadSectors() {
      this.loading = true;
      //Buscar primeiro do crop
      try {
        let managementSectors = []
        if (this.managementAccess){
          managementSectors = await managementSectorUseCases().show.execute()
        }

        let sectors_data = await sectors.list();

        if (this.managementAccess && managementSectors[0].length && sectors_data.length) {
          for (let management_sector of managementSectors[0]) {
            let sector = sectors_data.find(
              (sector) => sector.ID == management_sector.ID_SECTOR
            );

            if (sector) {
              sector.DATE_CROP = management_sector.DATE_CROP;
              sector.VOLUME_DATE = management_sector.VOLUME_DATE;
              sector.OFFSET_DAP = management_sector.OFFSET_DAP;
              sector.PRESSURIZE_TIME = management_sector.PRESSURIZE_TIME;
              sector.TIME_ADVANCE = management_sector.TIME_ADVANCE;
              sector.AVG_TIME_PULSE = management_sector.AVG_TIME_PULSE;
              sector.APPLICATION_RATE = management_sector.APPLICATION_RATE;
              sector.SYSTEM_EFFICIENCY = management_sector.SYSTEM_EFFICIENCY;
              sector.SPACING_BETWEEN_LINES =
                management_sector.SPACING_BETWEEN_LINES;
              sector.SPACING_BETWEEN_PLANTS =
                management_sector.SPACING_BETWEEN_PLANTS;
              sector.ID_SOIL = management_sector.ID_SOIL;
              sector.ID_FARM = management_sector.ID_FARM;
              sector.INITIAL_STORAGE = management_sector.INITIAL_STORAGE;
              sector.IS_MANAGEMENT = Boolean(management_sector.IS_MANAGEMENT);
            }
          }
        }

        this.list = sectors_data;
        this.fullList = this.list.map((e) => e);
        this.loading = false;

        if (
          !this.list.length &&
          this.showErrorNotSearch === false &&
          !this.loading
        ) {
          this.showErrorNotFound = true;
        } else {
          this.showErrorNotFound = false;
        }
      } catch (error) {
        this.loading = false;
        console.log("Falha ao carregar setores - ", error);
        alert("Ocorreu um erro ao carregar os setores. Recarregue a página.");
      }
    },
    loadEquipments() {
      sectors
        .hydros()
        .then((ret) => {
          this.hydros = ret;
          return sectors.pumps();
        })
        .then((ret) => {
          this.pumps = ret;
          return sectors.valves();
        })
        .then((ret) => {
          this.valves = ret;
          return sectors.sensors();
        })
        .then((ret) => {
          this.sensors = ret;
        })
        .catch((err) => {
          console.log(err);
          alert("Erro ao buscar equipamentos para formulário.");
        });
    },
    openDetails(item) {
      this.item = item;
      console.log(this.item)
      this.showDetails = true;
    },
    formatDate(date) {
      date = date.split("-");
      date = date[2] + "/" + date[1] + "/" + date[0];
      return date;
    },
    removeDialog() {
      this.$refs.removeSectorDialog.show();
    },
    async deleteCadSectorInManagement() {
      if (!this.managementAccess){
        return Promise.resolve()
      }
      for (let item of this.selected) {
        console.log ('aqui')
        await managementSectorUseCases()
          .deleteById.execute(item.ID)
          .catch((err) =>
            console.error(
              "Falha ao deletar setor de manejo - ",
              item.NAME,
              " ",
              err
            )
          );
        await deleteLogSectorByIdUseCase().execute(item.ID);
        await deleteManagementByIdSector().execute(item.ID);
        await deleteVolumeBySector().execute(item.ID);
      }
    },
    confirmRemove() {
      sectors
        
        .then(async (ret) => {
          alert(ret.log, ret.alert);
          if (ret.alert == "s") {
            return this.deleteCadSectorInManagement();
          }
        })
        .then((_) => {
          return this.loadSectors();
        })
        .then((_) => this.loadEquipments())
        .catch((err) => {
          console.error(err);
          alert("Ocorreu um erro na exclusão dos setores selecionados.");
        })
        .finally(() => {
          this.resetPage();
          this.$refs.removeSectorDialog.hide();
        });
    },
    edit() {
      this.formType = "edit";
      this.showForm = true;
    },
    add() {
      this.formType = "add";
      this.resetPage();
      this.showForm = true;
      // this.$refs.sectorFormModal.show();
    },
    getTimes(ret) {
      let times = ret.map((el) => {
        return [el.TIME];
      });
      return times;
    },
    reload(ret = null) {
      this.loadSectors();
      this.loadEquipments();
      this.resetPage();
    },
    resetPage() {
      this.selected = [];
    },
    searchBy(filter) {
      this.selected = [];
      this.isSearching = !!filter.split(" ").join("");
      this.filter = filter.toUpperCase();
      if (this.isSearching && this.validFilter && this.fullList.length) {
        this.list = this.fullList.filter(
          (item) => item.NAME.indexOf(this.filter) > -1
        );
        if (this.list.length) {
          this.showErrorNotSearch = false;
        } else {
          this.showErrorNotSearch = true;
        }
      } else {
        this.list = this.fullList.map((e) => e);
      }
    },
    clearSearch() {
      this.selected = [];
      this.isSearching = false;
      this.showErrorNotSearch = false;
      this.$refs.INP.clearText();
      this.list = this.fullList.map((e) => e);
    },
    // async onSubmitForm(SECTOR_PROPS) {
    //   const hasManagementProps = Reflect.has(SECTOR_PROPS, "MANAGEMENT");
    //   const isManagementSector = hasManagementProps
    //     ? SECTOR_PROPS.MANAGEMENT.IS_MANAGEMENT
    //     : null;


    //   this.isSectorRegister = true;

    //   this.loading = true;

    //   this.currentLoadingMessage = "Aguarde...";
    //   sectors[this.formType](SECTOR_PROPS.SECTOR)
    //     .then(async (ret) => {
    //       alert(ret.log, ret.alert);

    //       if (ret.alert !== "s") {
    //         throw new Error("Falha ao cadastrar dados do setor - ", ret.log);
    //       }

    //       //Só irá realizar os cálculos se não tiver editado somente o input de NOTE
    //       if (!SECTOR_PROPS.HAS_CHANGED_ONLY_NOTE && this.managementAccess) {
    //         if (hasManagementProps && isManagementSector) {
    //           this.currentLoadingMessage = this.loadingMessages.actuator.get;
    //           this.currentValves = await this.getValveInfo(SECTOR_PROPS);

    //           const hasFarmDap = await checkIfFarmDapExists.execute(
    //             SECTOR_PROPS.MANAGEMENT.ID_FARM
    //           );

    //           if (!hasFarmDap) {
    //             throw "Não existe dados de DAP do cultivar, não irá ser possível calcular o manejo!";
    //           }

    //           const sectorId =
    //             SECTOR_PROPS.MANAGEMENT.ID_SECTOR || SECTOR_PROPS.SECTOR.ID;

    //           const rainfall_inputs =
    //             await getManagementRainfallInputByIdlUseCase().execute(
    //               sectorId
    //             );

    //           if (this.formType === "add") {
    //             SECTOR_PROPS.MANAGEMENT.ID_SECTOR = ret.value;

    //             this.currentLoadingMessage = this.loadingMessages.sector.create;
    //             await managementSectorUseCases()[this.formType].execute(
    //               SECTOR_PROPS.MANAGEMENT
    //             );

    //             //Calcula e Registra ET0, Volume e Precipitação
    //             await this.registerManagementSectorAux(SECTOR_PROPS);
    //           } else if (this.formType === "edit") {
    //             this.currentLoadingMessage = this.loadingMessages.sector.update;

    //             await this.updateSectorHandler(SECTOR_PROPS);
    //           }

    //           this.currentLoadingMessage = this.loadingMessages.management.calc;
    //           const managementData = await this.calcManagementData(
    //             SECTOR_PROPS,
    //             rainfall_inputs
    //           );

    //           if (managementData.length) {
    //             this.currentLoadingMessage =
    //               this.loadingMessages.management.create;
    //             await this.registerManagement(sectorId, managementData);
    //           }
    //         }
    //         //Se estou editando um setor de manejo e agora estou dizendo que não vai ser de manejo
    //         else {
    //           //Se Não tiver SECTOR.ID e não tiver MANAGEMENT.ID_SECTOR -> Estou criado um setor que não é de manejo
    //           const sectorId =
    //             SECTOR_PROPS.SECTOR.ID || SECTOR_PROPS.MANAGEMENT.ID_SECTOR;

    //           if (sectorId) {
    //             if (SECTOR_PROPS.MANAGEMENT.ID_SECTOR != null) {
    //               this.currentLoadingMessage =
    //                 this.loadingMessages.management.delete;
    //             }
    //             await this.deleteManagementDatasFromSector(sectorId);
    //           }
    //         }
    //       }

    //       const ID_USER = cookies.get("ID");
    //       // Como é uma feature provísória que usa a rota da api "/sql" se tiver desabilitado
    //       // o acesso de manejo no banco então não irá conseguir chamar essa rota

    //       if(this.managementAccess){
    //         await managementSectorUseCases().updateFkEditor.execute(
    //           SECTOR_PROPS.SECTOR.ID || SECTOR_PROPS.MANAGEMENT.ID_SECTOR,
    //           ID_USER
    //         );
    //       }

    //       this.reload();
    //     })
    //     .catch((err) => {
    //       console.error(err);
    //       alert(
    //         `Ocorreu um erro ao ${
    //           this.formType == "add" ? "adicionar" : "editar"
    //         } setor. Erro: ${err}`,
    //         "e"
    //       );
    //     })
    //     .finally(() => {
    //       this.showForm = false;
    //       this.recalcUntilDateCrop = false;
    //       this.loading = false;
    //     });
    // },
  },
};
</script>
<style scoped>
.sector-card {
  height: 230px;
}

.header {
  flex-basis: 34px;
}

.header-card h5 {
  font-family: "SourceSansPro_Semibold", Arial, Helvetica, sans-serif;
  color: var(--text-gray-primary);
}

.header-card .material-design-icon {
  font-size: 1.1rem;
}

.sector-card .edited-icon,
.row-details-card .material-design-icon,
.sector-icon {
  color: var(--text-gray-tertiary);
  vertical-align: -2px;
}

.management-icon {
  color: #81b399;
  vertical-align: -0px;
  margin-right: 8px;
}

#details {
  padding-top: 100px;
  padding-bottom: 0 !important;
}

#details .content {
  padding-bottom: 0 !important;
}

.info {
  color: var(--text-gray-primary);
  margin-right: 5px;
}

.show-details-cards {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.row-details-card {
  width: 100%;
  padding: 0;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  font-size: 0.8em;
  color: var(--text-gray-primary);
}

.row-details-card .obs {
  max-width: 50%;
  overflow: hidden;
  text-overflow: ellipsis;
}

.row-details-card span {
  font-weight: 500;
  color: var(--text-gray-primary);
}

.show-details-cards a {
  padding: 3px 6px;
  border-radius: 5px;
  border: 1px solid #bebebe;
  font-weight: 500;
  font-size: 0.7em;
  color: #a1a1a1;
  transition: all 0.4s ease;
}

.show-details-cards a:hover {
  background: #f5f5f5;
}

.footer {
  height: 35px;
  padding: 0 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-mobile {
  min-height: 29px;
}

#details .content {
  margin-bottom: 60px;
}

@media screen and (max-width: 767px) {
  #details .content {
    margin-bottom: 0;
    padding-bottom: 90px !important;
  }

  .header {
    min-height: 90px;
  }

  #form {
    padding: 8px 0px 3em 0px;
  }

  #form,
  #details {
    padding-top: 2.5em;
  }
}
</style>
